import { InjectedProps as WithRouterPathProps, withRouterPath } from 'platform-components/hocs';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentClass, getIsPrimarySchool } from 'common.components/user/selectors';
import { getHasGradeDifference } from 'store/subject-config/selectors';
import * as themesSelectors from 'store/themes/selectors';

import { ReduxTeacherStore } from '../../typings';
import { getSubjectPages } from '../library.store/selectors';

import SubjectPageInfo from './__info/subject-page__info';
import SubjectThemes from './__subject-themes/subject-page__subject-themes';

import './subject-page.scss';

type StoreProps = ReturnType<typeof mapStateToProps>;

interface HOCProps extends WithRouterPathProps {}

interface Props extends HOCProps, StoreProps {}

export const SubjectPage = (props: Props) => {
    const {
        subjectPages,
        match: {
            params: { subject },
        },
        hasGradeDifference,
        plainThemes,
        promotedThemes,
        shouldShowActualThemes,
        currentTeam,
    } = props;

    return (
        <div className="subject-page">
            <SubjectPageInfo
                currentTeam={currentTeam}
                hasGradeDifference={hasGradeDifference}
                subject={subject}
                subjectPages={subjectPages}
            />
            <SubjectThemes
                plainThemes={plainThemes}
                promotedThemes={promotedThemes}
                shouldShowActualThemes={shouldShowActualThemes}
            />
        </div>
    );
};

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps) => {
    const {
        location: { search },
        match: {
            params: { subject, classId },
        },
    } = ownProps;
    const query = qs.parse(search);
    const currentTeam = getCurrentClass(storeState, { classId });
    const grade = currentTeam?.level || Number(query.grade);

    return {
        isPrimarySchool: getIsPrimarySchool(storeState, { classId }),
        subjectPages: getSubjectPages(storeState, { subject, grade }),
        currentTeam,
        plainThemes: themesSelectors.getPlainThemes(storeState, { subject, grade }),
        promotedThemes: themesSelectors.getPromotedThemes(storeState, { subject, grade }),
        shouldShowActualThemes: themesSelectors.getShouldShowActualThemes(storeState, { classId, subject }),
        hasGradeDifference: getHasGradeDifference(storeState, { subject }),
    };
};

export default withRouterPath(connect(mapStateToProps)(SubjectPage));
